const logger = {
   
  warn: console.warn,
   
  error: console.error,
}

export default logger
